export const getClients = () => {
  const queryParams = new URLSearchParams(window.location.search);

  return queryParams.getAll('client');
};

function decodeFromUrl(encodedString: string | null) {
  if (!encodedString) return [];

  const decodedString = decodeURIComponent(encodedString);
  return JSON.parse(decodedString);
}

export const getForceClients = () => {
  const queryParams = new URLSearchParams(window.location.search);

  const forceClients = queryParams.get('forceClients');

  return decodeFromUrl(forceClients);
};
